import { useEffect, useState } from 'react';

export function useStartOrderCoverScreen(cart: Record<string, any>, shouldShowStartOrderScreen: boolean) {
  const [isOpen, setIsOpen] = useState(true);
  const [wasOrderCompleted, setWasOrderCompleted] = useState(false);

  useEffect(() => {
    if (shouldShowStartOrderScreen && !wasOrderCompleted) {
      setIsOpen(true);
      setWasOrderCompleted(true);
      return;
    }
    if (!shouldShowStartOrderScreen && wasOrderCompleted) {
      setWasOrderCompleted(false);
    }
  }, [cart, shouldShowStartOrderScreen, wasOrderCompleted]);

  function open() {
    setIsOpen(true);
  }
  function close() {
    setIsOpen(false);
  }

  return {
    isOpen,
    open,
    close,
  };
}
